import React from 'react'
import './Presidente.css'

const Presidente = () => {
  const presidentes = [
    {
      name: 'Presidente Anterior 1',
      role: 'Presidente ASJF 2022-2024',
      img: '/presidente1.jpg',
    },
    {
      name: 'Presidente Anterior 2',
      role: 'Presidente ASJF 2020-2022',
      img: '/presidente2.jpg',
    },
  ]

  return (
    <main className="presidentePage">
      <div className="presidenteContent">
        <section className="presidenteHeader">
          <h1>Presidentes Anteriores</h1>
          <p>
            Uma breve retrospectiva dos presidentes anteriores da ASJF,
            com destaque para os nomes e mandatos que deram forma à nossa história.
          </p>
        </section>

        <section className="presidenteGrid">
          {presidentes.map((presidente) => (
            <article key={presidente.name} className="presidenteCard">
              <div className="presidentePhoto">
                <img src={presidente.img} alt={presidente.name} />
              </div>
              <h2 className="presidenteName">{presidente.name}</h2>
              <p className="presidenteRole">{presidente.role}</p>
            </article>
          ))}
        </section>
      </div>
    </main>
  )
}

export default Presidente